import {useContext} from 'react';
import {StoreContext} from '@roc/feature-app-core';
import {DealRoomTopicCommunicationStore} from '../stores/dealRoomTopicCommunicationStore';
export const useDealRoomTopicComunicationStore=() => useContext<{
  dealRoomTopicCommunicationStore: DealRoomTopicCommunicationStore
}>(StoreContext);
